import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  active: "",
};

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    setActiveLink: (state, action) => {
      state.active = action.payload;
    },
  },
});

export const { setActiveLink } = sidebarSlice.actions;
export default sidebarSlice.reducer;
